import { ReactElement } from 'react';

import type { WithTagsInjectedProps } from 'hocs';
import { withTags } from 'hocs';

import { useTagFetch } from '../hooks/useTagFetch';

interface Props<TAction> extends WithTagsInjectedProps {
  render: (tags: WithTagsInjectedProps['tags']) => ReactElement;
  actions: Array<TAction> | null;
}

function TagFetchImpl<TAction = unknown>({
  render,
  actions,
  tags,
}: Props<TAction>): JSX.Element {
  useTagFetch<TAction>(tags, actions);
  return render(tags);
}

export const TagFetch = withTags(TagFetchImpl);
